module.exports = __webpack_public_path__ + "sunsemweb/img/ws2.fae8d97a.png";